import { useQuery } from "react-query";
import { QueryReturnType } from "../../services/networking.service";
import ENDPOINTS from "../../services/endPoints";

interface IProps {
  page: string;
  limit: string;
  search: string;
  /** '1' = active only | '0' = disabled only | 'all' = both. Default: '1' */
  status?: string;
  /** Defaults to true (existing behavior) - pass false to defer fetching, e.g. until a
   * modal that needs this list is actually open. */
  enabled?: boolean;
}

export const useGetKeyHost = ({
  page,
  limit,
  search,
  status = '1',
  enabled = true,
}: IProps): QueryReturnType<any> => {
  return useQuery<never, never, any>(
    [ENDPOINTS.GET_KEY_HOST, { page, limit, search, status }],
    {
      enabled,
      retry: false,
      refetchOnWindowFocus: false,
      refetchOnMount: 'always',
      notifyOnChangeProps: [
        "data",
        "error",
        "refetch",
        "isRefetching",
        "isSuccess",
        "isLoading",
      ],
    }
  );
};
